import { AnalyticsContext } from '@carvana/eventable-clickstream';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Button from '|/components/base/button';

const SupportHeaderButton = styled(Button)`
  width: 145px;
  min-height: 31px;
  flex-shrink: 0;
  border-radius: 30px;
  background: #106bc7;
`;

const SupportButtonText = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 400;
  color: var(--colors-neutral-white);
  text-align: center;
  font-size: 14px;
  line-height: 12px;
  text-transform: none;
`;

const defaultProps = {
  setIsOpen: (_boolean: boolean) => {}
};

export const SupportContactButton = ({ setIsOpen } = defaultProps) => {
  const { trackEvent } = useContext(AnalyticsContext);

  const openSupportContact = () => {
    setIsOpen(true);
    trackEvent('pp_clicked_support_and_contact');
  };

  return (
    <SupportHeaderButton
      disabled={false}
      onClick={() => openSupportContact()}
      data-analytics-id="pp_header_support_contact"
    >
      <SupportButtonText>Support & Contact</SupportButtonText>
    </SupportHeaderButton>
  );
};
